"use strict";

import * as bootstrap from 'bootstrap';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';

window.bootstrap = bootstrap; // ora puoi usare window.bootstrap.Tooltip ecc.
window.gsap = gsap;
gsap.registerPlugin(CSSPlugin);

export { bootstrap, gsap };
